import { render, staticRenderFns } from "./fileAnswerIcon.vue?vue&type=template&id=0ce7fd0a&scoped=true"
import script from "./fileAnswerIcon.vue?vue&type=script&lang=js"
export * from "./fileAnswerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce7fd0a",
  null
  
)

export default component.exports